import { Box } from '@mui/material';
import { useMemo } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';
import { getChildHeadingId } from '../../utils';

export type ContentSectionProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export const ContentSection = (sccProps: ContentSectionProps) => {
  const {
    props: { children },
  } = sccProps;

  const headingId = useMemo(() => getChildHeadingId(sccProps), [sccProps.props.children]);
  return (
    <Box component="section" aria-labelledby={headingId}>
      <StructuredContentRenderer doc={children} />
    </Box>
  );
};
